import configs from "@/i18n/configs"
export default {
    today: 'اليوم',
    'filter': 'فلتر',
    'tabs': {
        'doctor': `${configs.doctor.ar}`,
        'pharmacy': `${configs.pharmacy.ar}`,
        'center': `${configs.center.ar}`
    },
    'add-visit': 'إضافة زيارة',
    'the-visit': 'الزيارة'
}